export enum SignDocumentRouteNames {
  SIGN_DOCUMENT_TABLE = "DocumentTableView",
  SIGN_DOCUMENT_DETAIL = "SignDocumentDetailView",
  SIGN_DOCUMENT_FORM = "SignDocumentFormView",
  SIGN_REQUEST_TABLE = "SIGN_REQUEST_TABLE",
  SIGN_REQUEST_DETAIL = "SignRequestDetailView",
  SIGN_REQUEST_FORM = "SignRequestFormView"
}
